import { makeStyles } from 'tss-react/mui'
import { FormattedMessage } from 'react-intl'
import NotificationIcon from './NotificationIcon'

const useStyles = makeStyles()((theme) => {
  return {
    body: {
      minHeight: '400px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    notificationIcon: {
      fontSize: theme.typography.pxToRem(100),
      justifyContent: 'center',
      width: '100%',
      marginBottom: theme.spacing(5),
    },
    content: {
      textAlign: 'center',
    },
  }
})

const NoResults = () => {
  const { classes } = useStyles()

  return (
    <div className={classes.body}>
      <div>
        <NotificationIcon className={classes.notificationIcon} />
        <div className={classes.content}>
          <h3>
            <FormattedMessage
              id="NO_RECENT_NOTIFICATIONS"
              defaultMessage="No Recent Notifications"
            />
          </h3>
          <span>
            <FormattedMessage
              id="PLEASE_CHECK_BACK_LATER"
              defaultMessage="Please check back later"
            />
          </span>
        </div>
      </div>
    </div>
  )
}

export default NoResults
